export default "__VITE_ASSET__BBFG1y9R__"